import * as React from "react";
const SvgFiRrLightbulbHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lightbulb-head_svg__a)">
      <path
        fill="#062147"
        d="M23.082 15.4a11 11 0 0 1-1.343 2.274c-.477.623-.739 1.458-.739 2.354v.97c0 1.655-1.346 3-3 3h-7c-1.654 0-3-1.345-3-3h-.494a5.014 5.014 0 0 1-4.957-4.344l-.219-1.655H2c-1.299 0-2-1.03-2-2 0-1.42 2.932-7.015 4.223-8.611A11 11 0 0 1 11.901.055a1 1 0 0 1 .198 1.99A9.02 9.02 0 0 0 5.8 5.618c-1.342 1.66-3.718 6.575-3.801 7.407L3.207 13a1 1 0 0 1 .991.869l.334 2.524A3.01 3.01 0 0 0 7.506 19H9a1 1 0 0 1 1 1v1c0 .55.449 1 1 1h7c.552 0 1-.45 1-1v-.971c0-1.333.409-2.601 1.151-3.57a9 9 0 0 0 1.099-1.86 1 1 0 0 1 1.832.802zM14.135 3.827a4.95 4.95 0 0 1 3.688-3.69c1.525-.35 3.087-.005 4.288.949A4.98 4.98 0 0 1 24.001 5a4.97 4.97 0 0 1-2.213 4.137c-.493.33-.788.928-.788 1.599v.763c0 .829-.672 1.502-1.499 1.502h-1c-.827 0-1.5-.673-1.5-1.5v-.772c0-.657-.3-1.265-.782-1.587-1.74-1.164-2.558-3.25-2.083-5.314zm3.194 3.65c.563.377.989.91 1.276 1.523h.791a3.7 3.7 0 0 1 1.277-1.524 2.986 2.986 0 0 0 .191-4.826 2.95 2.95 0 0 0-1.858-.651q-.363 0-.735.085a2.98 2.98 0 0 0-2.188 2.19c-.291 1.267.186 2.494 1.245 3.203z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lightbulb-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightbulbHead;
